import React from 'react'
import { ErrorBlock } from 'antd-mobile'

const PageNotFound: React.FC = () => {
  return (
    <div>
      <ErrorBlock fullPage status="empty" />
    </div>
  )
}

export default PageNotFound
